import { ApolloLink, InMemoryCache } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
import { MultiAPILink } from "@habx/apollo-multi-endpoint-link";
import { RestLink } from "apollo-link-rest";
import { camelizer } from "@stadium/helpers/formatter";
import camelCase from "lodash/camelCase";
import snakeCase from "lodash/snakeCase";

// ToDo: Remove this dependency on another service
// eslint-disable-next-line import/no-extraneous-dependencies
import { showError } from "@stadium/services/toastr";

const emptyObj = {};

export const getRestLink = (linkOptions) => {
  const {
    restEndpoint,
    // customHeaders = emptyObj,
  } = linkOptions || emptyObj;
  return new RestLink({
    uri: restEndpoint,
    fieldNameNormalizer: (key) => camelCase(key),
    fieldNameDenormalizer: (key) => snakeCase(key),
    // responseTransformer: async response => {
    //   const data = await response.json()
    //   return jsonDataFormatter(data)
    // }
  });
};

export const getHttpLink = (linkOptions) => {
  const {
    endpoints,
    default: defaultEndpoint = "",
    // customHeaders = emptyObj,
  } = linkOptions || emptyObj;
  return new MultiAPILink({
    endpoints,
    httpSuffix: "",
    defaultEndpoint,
    createHttpLink: () => createUploadLink(),
  });
};

export const authMiddleware = (token) =>
  new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      },
    }));

    return forward(operation);
  });

export const errorMiddleWare = onError((err) => {
  const { graphQLErrors, networkError } = err;
  if (graphQLErrors) {
    graphQLErrors.map(({ message }) => showError(message));
  }
  if (networkError) {
    const { name, message, response } = networkError;
    const { status = 500, statusText } = response || emptyObj;
    switch (status) {
      case 401:
        return showError(`${status} - ${message}`);
      default:
        return showError(`${name}: ${status} - ${statusText || message}`);
    }
  }
});

export const camelizeMiddleWare = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    if (response.data) {
      response.data = camelizer(response.data);
    }
    return response;
  })
);

export const cache = new InMemoryCache();
